<p class="text-center">
    <i class="fa fa-4x fa-spinner fa-spin spinner-color"></i>
    {{ loadingMessage }}
</p>